<template>
    <section class="content" style="background-color: #EBECF1">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-info">
                    <div class="box-header">
                        <!--- <h2>Detalles del Área: {{ this.descripcionArea }}</h2> ---->
                        <!--- <h3 class="fuente box-title p-t-5">Detalle del Área:</h3> --->
                        <h3 class="fuente box-title p-t-12">PERSONAL DEL ÁREA: {{ this.descripcionArea }}</h3>
                    </div>
                    <div class="box-body">
                        <div id="area">
                            <form role="form">
                                <div class="box-footer" style="padding-left:15px;">
                                    <!-- <h3 class="fuente box-title p-t-10">PERSONAL</h3> -->
                                    <button type="button" class="fuente btn btn-primary fs-13" @click="limpiar()"
                                        data-toggle="modal" data-target="#modalNuevo">Nuevo Registro
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="fuente col-xs-12 table-responsive">
                                        <div class="box-body">
                                            <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                                                class="fuente fs-12 table table-bordered table-striped dataTable">
                                                <thead>
                                                    <tr role="row">
                                                        <th aria-label="ITEM" aria-sort="ascending"
                                                            aria-controls="tablaDetalle" tabindex="0"
                                                            class="sorting_asc">
                                                            ITEM</th>
                                                        <th aria-label="DNI" aria-controls="tablaDetalle" tabindex="0"
                                                            class="sorting">
                                                            DNI</th>
                                                        <th aria-label="NOMBRE" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">
                                                            NOMBRE</th>
                                                        <th aria-label="CARGO" aria-controls="tablaDetalle" tabindex="0"
                                                            class="sorting">CARGO</th>
                                                        <th aria-label="CORREO" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">CORREO</th>
                                                        <th aria-label="SIGLA" aria-controls="tablaDetalle" tabindex="0"
                                                            class="sorting">SIGLA</th>
                                                        <th aria-label="FECHA NACIMIENTO" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">
                                                            FECHA NACIMIENTO</th>
                                                        <th aria-label="USUARIO" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">USUARIO</th>
                                                        <th aria-label="USUARIO" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">SETEO</th>
                                                        <th aria-label="USUARIO" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting">DEFECTO</th>
                                                        <th aria-label="DETALLE" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting table-center-header">
                                                            DETALLE
                                                        </th>
                                                        <th aria-label="ANULAR" aria-controls="tablaDetalle"
                                                            tabindex="0" class="sorting table-center-header">ANULAR</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="even" role="row" v-for="item in personas">
                                                        <td class="sorting_1">{{ item.cont }}</td>
                                                        <td>{{ item.dni }}</td>
                                                        <td>{{ item.nombres }} {{ item.apePaterno }} {{ item.apeMaterno
                                                            }}
                                                        </td>
                                                        <td>{{ item.cargo }}</td>
                                                        <td>{{ item.correo }}</td>
                                                        <td>{{ item.sigla }}</td>
                                                        <td>{{ formatDate(item.fecNacimiento) }}</td>
                                                        <td>{{ item.nomUsuario }}</td>
                                                        <td>{{ item.seteo }}</td>
                                                        <td>{{ item.defecto }}</td>
                                                        <td class="table-center-header">
                                                            <router-link
                                                                :to="{ name: 'usuarios', params: { idTrab: item.idTrabajador } }">
                                                                <span @click="enviar(item)"
                                                                    class="badge bg-yellow">V</span>
                                                            </router-link>
                                                        </td>
                                                        <td class="table-center-header">
                                                            <span style="cursor:pointer" class="badge bg-red"
                                                                data-toggle="modal" @click="verAnular(item)"
                                                                data-target="#modalAnular">X</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="fuente col-md-12" style="color: red;">
                                            {{ error.desError }}
                                        </div>
                                    </div>
                                </div>
                                <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog"
                                    aria-labelledby="myModalLabel">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <form>
                                                <div class="modal-header">
                                                    <button type="button" class="close" data-dismiss="modal"
                                                        aria-label="Close"><span aria-hidden="true">X</span></button>
                                                    <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}
                                                    </h4>
                                                </div>
                                                <div class="fuente modal-body fs-12">
                                                    <div class="row">
                                                        <div class="col-md-1"></div>
                                                        <div class="col-md-4 m-b-10">
                                                            Flag Seteo:
                                                            <input type="checkbox" v-model="usuByArea.flagSeteo"
                                                                true-value="1" false-value="0">
                                                        </div>
                                                        <div class="col-md-4">
                                                            Flag Defecto:
                                                            <input type="checkbox" v-model="usuByArea.flagDefecto"
                                                                true-value="1" false-value="0"><br /><br />
                                                        </div>
                                                    </div><br>
                                                    <div class="row">
                                                        <!---- v-select para obtener todos los usuarios-->
                                                        <div class="usuario-container">
                                                            <span class="usuario-label">Personal:</span><br />
                                                            <!--- Se filtra y muestra todos los usuarios en el combobox con campo de búsqueda-->
                                                            <v-select v-model="selectedIdPersonal"
                                                                :options="filteredUsuarios" :filterable="true"
                                                                label="nombreCompleto" @input="selectPersonal"
                                                                class="fuente form-control m-t-10 m-b-10 combobox-personalizado3"
                                                                placeholder="Seleccionar"
                                                                style="max-width: 550px; padding: 0px; border-style: hidden;">
                                                                <template v-slot:no-options="{ search }">
                                                                    Lo siento, no hay usuarios que coincidan con "{{
                            search
                        }}".
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="fuente col-xs-12 table-responsive">
                                                            <div class="box-body">
                                                                <table aria-describedby="tablaDetalle_info" role="grid"
                                                                    id="tablaUsers"
                                                                    class="fuente fs-12 table table-bordered table-striped dataTable">
                                                                    <thead>
                                                                        <tr role="row">
                                                                            <th aria-label="ITEM" aria-sort="ascending"
                                                                                aria-controls="tablaUsers" tabindex="0"
                                                                                class="sorting_asc">ITEM</th>
                                                                            <th aria-label="NOMBRE USUARIO"
                                                                                aria-controls="tablaUsers" tabindex="0"
                                                                                class="sorting">NOMBRE
                                                                                USUARIO
                                                                            </th>
                                                                            <th aria-label="AGREGAR"
                                                                                aria-controls="tablaUsers" tabindex="0"
                                                                                class="sorting table-center-header">
                                                                                AGREGAR
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr class="even" role="row" v-for="item in users">
                                                                            <td class="sorting_1">{{ item.cont }}</td>
                                                                            <td>{{ item.nomUsuario }}</td>
                                                                            <td><button type="button"
                                                                                    class="fuente btn btn-primary fs-12 enabled-button"
                                                                                    @click="mergeUsuByArea(item.idUsuario)"
                                                                                    data-dismiss="modal"> AGREGAR
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div v-if="this.users.length === 0" class="modal-footer">
                                                                <button type="button"
                                                                    class="fuente btn btn-primary fs-12 disabled-button"
                                                                    @click="mergeUsuByArea(item.idUsuario)"
                                                                    data-dismiss="modal"
                                                                    :disabled="this.usuByArea.idUsuario = '0'"
                                                                    :title="'Seleccione un usuario'">AGREGAR
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog"
                                    aria-labelledby="myModalLabel">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <form>
                                                <div class="modal-header">
                                                    <button type="button" class="close" data-dismiss="modal"
                                                        aria-label="Close"><span aria-hidden="true">X</span></button>
                                                    <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS
                                                        ANULAR A
                                                        ESTE USUARIO DEL ÁREA?</h4>
                                                </div>
                                                <div class="fuente modal-body">
                                                    Se anulará a {{ usuByArea.nombres }} {{ usuByArea.apePaterno }}
                                                    {{ usuByArea.apeMaterno }} de esta área. <br />
                                                </div>
                                                <div class="modal-footer">
                                                    <button type="button" class="fuente btn btn-danger fs-13"
                                                        @click="anularUsuByArea(usuByArea)" data-dismiss="modal">Anular
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import { apiURL } from '@/store/state'
import $ from 'jquery'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
    name: 'Tables',
    data() {
        return {
            personas: [],
            allUsuarios: [], //// todos los usuarios
            users: [], ///los usuarios x persona
            error: {
                desError: ''
            },
            error2: {
                desError: ''
            },
            texto: '',
            vidUsu: '0',
            vidTrab: '0',
            persona: {
                idTrabajador: '0',
                dni: '',
                nombres: '',
                apePaterno: '',
                apeMaterno: '',
                cargo: '',
                correo: '',
                sigla: '',
                fecha_nac: new Date(),
                idUsuario: '0',
                nomUsuario: '',
                idAreaXUsu: '0',
                flagSeteo: '0',
                flagDefecto: '0',
                seteo: '',
                defecto: '',
                flagActivo: '1',
                usuario: this.$session.get('user')
            },
            usuByArea: {
                idArea: this.idArea,
                idAreaXUsu: '0',
                idUsuario: '0',
                flagSeteo: '0',
                flagDefecto: '0',
                flagActivo: '1',
                usuario: this.$session.get('user')
            },
            searchText: '',
            selectedIdPersonal: null,
            usuarioSeleccionado: {},
            idArea: localStorage.getItem('idArea'), // Obtener el id del Área
            descripcionArea: localStorage.getItem('desArea'), // Obtener la descripcion del Área
            tiempoActual: null,
            tiempoTokenExp: null
        }
    },    
    components: {
        vSelect
    },
    mounted() {        
        //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
        //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
        this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a"); 
        this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");

        if (this.tiempoActual < this.tiempoTokenExp) {
            if (this.idArea && this.idArea !== '' && this.descripcionArea && this.descripcionArea !== '') {
                this.cargarPersonal();
            } else {
                this.$router.go(-1)
            }            
        } else {
            this.alertaError401();
        }
    },
    methods: {
        cargarPersonal() {
            // Destruir la instancia DataTable si ya existe
            const dataTableInstance = $('#tablaDetalle').DataTable();
            if (dataTableInstance) {
                dataTableInstance.destroy();
            }            
            //// Obtener los registros para la tabla
            axios.defaults.headers.common['Authorization'] = this.$session.get('token')
            axios.get(`${apiURL}/usuarios/personas/` + this.idArea)
                .then(response => {
                    this.personas = response.data;
                    //console.log('Trabajadores obtenidos:', this.personas);
                    this.$nextTick(() => {
                        $('#tablaDetalle').DataTable({
                            stateSave: true,
                            'stateSaveParams': function (settings, data) {
                                data.length = 25; // Establece la cant. de registros de la tabla
                            },
                            'oLanguage': {
                                'sSearch': 'Buscar',
                                'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                                'sEmptyTable': 'Sin Data',
                                'ZeroRecords': 'No se encontraron coincidencias',
                                'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
                                'sLengthMenu': '_MENU_ Registros por pagina',
                                'oPaginate': {
                                    'sPrevious': 'Anterior',
                                    'sNext': 'Siguiente'
                                }
                            }
                        });
                    });
                })
                .catch(error => {
                    console.error('Error al obtener los datos:', error);
                    if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                });

        },
        limpiar: function () {
            axios.defaults.headers.common['Authorization'] = this.$session.get('token')
            axios.get(
                `${apiURL}/usuarios/*`
            ).then(response => {
                this.allUsuarios = response.data
                //console.log('... allUsuarios todos los usuarios', this.allUsuarios)
            })
                .catch(error => {
                    if (error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                })

            this.texto = 'AGREGAR UN NUEVO USUARIO AL ÁREA'
            this.selectedIdPersonal = null;
            this.usuarioSeleccionado = {}
            this.users = []

            this.usuByArea.idAreaXUsu = '0'
            this.usuByArea.idUsuario = '0'
            this.usuByArea.flagSeteo = '0'
            this.usuByArea.flagDefecto = '0'
            this.usuByArea.flagActivo = '1'
            this.error.desError = ''

            /*
            // Destruir la instancia DataTable si ya existe
            const dataTableInstance2 = $('#tablaUsers').DataTable();
            if (dataTableInstance2) {
                dataTableInstance2.destroy();
            }
            */
        },
        mergeUsuByArea: function (vidUsu) {
            if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
                this.usuByArea.idUsuario = vidUsu
                axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                axios.post(
                    `${apiURL}/operaciones/areaByUsu/add`,
                    {
                        'idAreaXUsu': '0',
                        'idUsuario': this.usuByArea.idUsuario,
                        'idArea': this.idArea,
                        'flagActivo': this.usuByArea.flagActivo,
                        'flagSeteo': this.usuByArea.flagSeteo,
                        'flagDefecto': this.usuByArea.flagDefecto,
                        'usuario': this.$session.get('user')
                    }
                ).then(response => {
                    this.error = response.data
                    this.cargarPersonal();
                })
                    .catch(error => {
                        if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                        }
                    })
            } else {
                this.alertaError401();
            }
        },
        verAnular: function (usuByArea) {
            this.usuByArea = usuByArea
            //this.usuByArea.flagActivo = '0'
            this.error.desError = ''
        },
        anularUsuByArea: function (usuByArea) {
            if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
                //console.log('----- this usuByArea', this.usuByArea)
                this.usuByArea.idUsuario = usuByArea.idUsuario
                this.usuByArea.idAreaXUsu = usuByArea.idAreaXUsu

                axios.post(
                    `${apiURL}/operaciones/areaByUsu/add`,
                    {
                        'idAreaXUsu': this.usuByArea.idAreaXUsu,
                        'idUsuario': this.usuByArea.idUsuario,
                        'flagActivo': '0',
                        'usuario': this.$session.get('user')
                    }
                ).then(response => {
                    this.error = response.data
                    this.cargarPersonal();
                })
                    .catch(error => {
                        if (error.response.status === 401) {
                            App.methods.logout.call(this);
                        }
                    })
            } else {
                this.alertaError401();
            }
        },
        selectPersonal() {
            if (this.selectedIdPersonal && this.selectedIdPersonal.idTrabajador) {
                //console.log('Ejecutando selectPersonal', this.selectedIdPersonal);
                const newId = this.selectedIdPersonal.idTrabajador;

                // Busca el usuario seleccionado en el arreglo de usuarios
                const selectedUser = this.allUsuarios.find(u => u.idTrabajador === newId) || {};  
                // Actualiza el usuario seleccionado
                this.usuarioSeleccionado = selectedUser;
                //console.log('Usuario seleccionado:', this.usuarioSeleccionado);

                //Ejecuta el método para obtener todos los usuarios de la persona
                this.cargarUsuariosxPersona(this.usuarioSeleccionado.idTrabajador);
                ////Se marca automáticamente la casilla del checkbox flagSeteo (todos los usuarios agregados deben ser flagSeteo = '1')
                this.usuByArea.flagSeteo = '1';

            } else {
                // Manejar el caso cuando selectedIdPersonal es null o no tiene idTrabajador
                //console.warn('selectedIdPersonal es null o no tiene idTrabajador');
                //this.usuarioSeleccionado = {};                
                this.usuarioSeleccionado = {
                    idTrabajador: '0',
                    nombres: '',
                    apePaterno: '',
                    apeMaterno: '',
                };
                this.users = []
                ////Se desmarca automáticamente la casilla del checkbox flagSeteo
                this.usuByArea.flagSeteo = '0';
                this.usuByArea.flagDefecto = '0';
                //console.log('this.usuarioSeleccionado', this.usuarioSeleccionado)                
            }
        },
        cargarUsuariosxPersona: function (vidTrab) {
            axios.get(
                `${apiURL}/usuarios/trabajador/` + vidTrab
            ).then(response => {
                this.users = response.data
            })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                })
        },

        ////// formato para Fechas
        formatDate(dateString) {
            if (dateString) {
                const date = new Date(dateString);
                const day = ('0' + date.getDate()).slice(-2);
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            }
            return '';
        },
        enviar(item) {
            this.$store.commit('enviarCorreo', item.correo);
            localStorage.setItem('userIdTrab', item.idTrabajador)
            this.$router.push('/areas_detalle');
        },
        alertaError() {
            Swal.fire({
                icon: 'error',
                title: 'Usuario No Autorizado',
                text: 'No tienes permisos para acceder.',
                timer: 2000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                //this.$router.go(-1);
                this.$router.push('/login')
            });
        },
        alertaError401() {
            Swal.fire({
                icon: 'error',
                title: 'La sesión ha expirado',
                //text: 'Vuelve a iniciar sesión.',
                footer: '<a href="#">Vuelve a iniciar sesión.</a>',
                timer: 3000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                //this.$session.destroy()
                //this.$router.push('/login')
                App.methods.logout.call(this); ///Cierra la sesión                 
            });
        },
        alertaError500() {
            Swal.fire({
                icon: 'error',
                title: 'Error interno del servidor',
                text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
                timer: 5000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                //this.$router.go(-1);
                this.$router.push('/login')
            });
        },
    },
    computed: {
        filteredUsuarios() {
            const lowerSearchText = this.searchText.toLowerCase();
            //console.log('..this.allUsuarios', this.allUsuarios);
            return this.allUsuarios.map(usu => {
                // Verificamos que usu sea un objeto y tenga las propiedades necesarias
                if (usu && usu.nombres && usu.apePaterno && usu.apeMaterno) {
                    return {
                        ...usu,
                        //idTrabajador: usu.idTrabajador, 
                        nombreCompleto: `${usu.nombres} ${usu.apePaterno} ${usu.apeMaterno}`
                    };
                }
                return null;
            }).filter(usu => usu && (
                usu.nombres.toLowerCase().includes(lowerSearchText) ||
                usu.apePaterno.toLowerCase().includes(lowerSearchText) ||
                usu.apeMaterno.toLowerCase().includes(lowerSearchText)
            ));
        },
    },
    ///Para borrar los valores del Área actual al salir de la ventana
    beforeRouteLeave(to, from, next) {
        // Verifica si la ruta de destino NO es 'usuarios'
        if (to.name !== 'usuarios') {
            localStorage.removeItem('idArea')
            localStorage.removeItem('desArea')             
        }
        next();
    },
};
</script>

<style>
.usuario-container {
    margin-left: 5px;
}

.usuario-label {
    margin-left: 25px;
}

.disabled-button {
    margin-right: 25px;
    margin-top: -8px;
    margin-bottom: -8px;
}

@media (max-width: 767px) {
    .disabled-button {
        margin-right: 0px;
    }
}

.enabled-button {
    margin-left: 30px;
    margin-right: 0px;
}

@media (max-width: 767px) {
    .enabled-button {
        margin-left: 5px;
        margin-right: 5px;
    }
}

.fuente.box-title.p-t-12 {
    display: grid;
    place-items: center;
    font-weight: bold;
    /*text-decoration: underline;*/
}

.table-center-header {
    text-align: center;
    vertical-align: middle;
}

.combobox-personalizado3 {
    margin-left: 20px;
    width: 550px;
    font-size: 14px;
    /* font-weight: bold;*/
    font-family: "Arial";
    color: black;
}

@media (max-width: 767px) {
    .combobox-personalizado3 {
        width: 338px;
        /* Establece el ancho al 100% en dispositivos con un ancho de pantalla menor o igual a 767px */
        max-width: none;
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// Area_Detalle.vue?028fd6e8